/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconAstronaut3 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M17.2 7.5V6A5.25 5.25 0 0 0 6.7 6v1.5M2.2 23.25c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75" />
        <path d="M17.2 7.5c0 2.071-2.351 4.372-5.25 4.372S6.7 9.571 6.7 7.5s2.35-3.75 5.25-3.75S17.2 5.429 17.2 7.5zM15.323 18.622A1.874 1.874 0 1 0 17.2 20.5a1.874 1.874 0 0 0-1.875-1.875h0l-.002-.003zM7.448 18.622h3M7.448 21.622h3" />
        <path d="M6.8 8.25h-.1a3 3 0 0 0-3 3v6.8M20.2 18.051v-6.8a3 3 0 0 0-3-3h-.105" />
      </g>
    </svg>
  ),
);
